var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArtboard35(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        clip-path: url(#clip-Artboard_35);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3, .cls-4 {\r\n        fill: none;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 1.2px;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke: #b4b4b5;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke: #656fb2;\r\n      }\r\n\r\n      .cls-5 {\r\n        filter: url(#Ellipse_185);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_185",
    x: -0.921,
    y: 2.579,
    width: 46.842,
    height: 46.842,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#8082d0",
    floodOpacity: 0.157
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 46
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_35",
    "data-name": "Artboard \\u2013 35",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2486",
    "data-name": "Group 2486",
    transform: "translate(-10586.062 -6645.351)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5",
    transform: "matrix(1, 0, 0, 1, 10586.06, 6645.35)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_185-2",
    "data-name": "Ellipse 185",
    className: "cls-2",
    cx: 14.421,
    cy: 14.421,
    r: 14.421,
    transform: "translate(8.08 8.58)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    className: "cls-3",
    d: "M11.659,5.164a3.914,3.914,0,1,0-7.827,0c0,4.566-1.957,5.87-1.957,5.87H13.616s-1.957-1.3-1.957-5.87",
    transform: "translate(10600.816 6660.579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    className: "cls-3",
    d: "M8.676,13.125a1.3,1.3,0,0,1-2.257,0",
    transform: "translate(10601.015 6661.097)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167-2",
    "data-name": "Path 167",
    className: "cls-4",
    d: "M11.659,5.164a3.914,3.914,0,1,0-7.827,0c0,4.566-1.957,5.87-1.957,5.87H13.616s-1.957-1.3-1.957-5.87",
    transform: "translate(10600.816 6660.579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168-2",
    "data-name": "Path 168",
    className: "cls-4",
    d: "M8.676,13.125a1.3,1.3,0,0,1-2.257,0",
    transform: "translate(10601.015 6661.097)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtboard35);
export default __webpack_public_path__ + "static/media/Artboard – 35.5622911fd5b0aa6254fefb1d70bb0f3c.svg";
export { ForwardRef as ReactComponent };